import { extendTheme } from '@chakra-ui/react';
import { typography } from '@xqmsg/ui-core';
import breakpoints from './foundations/breakpoints';
import colors from './foundations/colors';
import shadows from './foundations/shadows';
import Accordion from './components/accordion';
import Badge from './components/badge';
import Button from './components/button';
import Code from './components/code';
import Link from './components/link';
import Menu from './components/menu';
import Modal from './components/modal';
import Switch from './components/switch';
import Checkbox from './components/checkbox';
import styles from './styles';

const customChakraTheme = extendTheme({
  breakpoints,
  colors,
  shadows,
  ...typography,
  components: {
    Accordion,
    Badge,
    Button,
    Code,
    Link,
    Menu,
    Modal,
    Switch,
    Checkbox,
  },
  styles,
});

export type CustomTheme = typeof customChakraTheme;

export default customChakraTheme;
